

export default {
  // Page title
  title: 'Tracking Configuration Management',

  // System preset data protection messages
  protection: {
    channelReadonly: 'CargoWare channel is a system preset and cannot be modified',
    businessReadonly: 'SE business under CargoWare channel is a system preset and cannot be modified',
    nodeReadonly: 'Nodes under CargoWare channel SE business are system presets and cannot be modified',
    nodeCannotAdd: 'Nodes under CargoWare channel SE business are system presets, cannot add new nodes',
    nodeCannotDelete: 'Nodes under CargoWare channel SE business are system presets and cannot be deleted',
    nodeCannotReorder: 'Nodes under CargoWare channel SE business are system presets and cannot be reordered'
  },
  subtitle: 'Data Channel Configuration',

  // Channel related
  channel: {
    title: 'Channel Management',
    code: 'Channel Code',
    nameCn: 'Channel Name (CN)',
    nameEn: 'Channel Name (EN)',
    type: 'Channel Type',
    enable: 'Enable Status',
    add: 'Add Channel',
    edit: 'Edit Channel',
    view: 'View Channel',
    delete: 'Delete Channel',
    deleteConfirm: 'Are you sure to delete this channel? All associated businesses and nodes will be deleted. This operation cannot be undone!',
    mainChannel: 'Main Channel',
    thirdPartyChannel: 'Third Party Channel',
    selectChannel: 'Please select a channel',
    inputCode: 'Please enter channel code',
    inputNameCn: 'Please enter channel name (CN)',
    inputNameEn: 'Please enter channel name (EN)',
    codeRequired: 'Channel code is required',
    nameCnRequired: 'Channel name (CN) is required',
    typeRequired: 'Please select channel type',
    codePattern: 'Channel code can only contain uppercase letters, numbers and underscores',
    codeExists: 'Channel code already exists'
  },

  // Business related
  business: {
    title: 'Business Management',
    code: 'Business Code',
    nameCn: 'Business Name (CN)',
    nameEn: 'Business Name (EN)',
    enable: 'Enable Status',
    add: 'Add Business',
    edit: 'Edit Business',
    view: 'View Business',
    delete: 'Delete Business',
    deleteConfirm: 'Are you sure to delete this business? All associated nodes will be deleted. This operation cannot be undone!',
    selectBusiness: 'Please select a business',
    inputCode: 'Please enter business code',
    inputNameCn: 'Please enter business name (CN)',
    inputNameEn: 'Please enter business name (EN)',
    codeRequired: 'Business code is required',
    nameCnRequired: 'Business name (CN) is required',
    codePattern: 'Business code can only contain uppercase letters, numbers and underscores',
    codeExists: 'Business code already exists',
    seExport: 'Sea Export',
    seImport: 'Sea Import',
    aeExport: 'Air Export',
    aeImport: 'Air Import',
    noBusinessTip: 'No business configured for current channel, please add business first'
  },

  // Node related
  node: {
    title: 'Node Management',
    code: 'Node Code',
    nameCn: 'Node Name (CN)',
    nameEn: 'Node Name (EN)',
    enable: 'Enable Status',
    externalDisplay: 'External Display',
    externalDisplayLabel: 'Display to external customers',
    icon: 'Node Icon',
    sort: 'Sort Order',
    add: 'Add Node',
    edit: 'Edit Node',
    view: 'View Node',
    delete: 'Delete Node',
    deleteConfirm: 'Are you sure to delete this node?',
    reset: 'Reset Nodes',
    resetConfirm: 'Are you sure to reset all node configurations? This will clear all nodes under current business!',
    inputCode: 'Please enter node code',
    inputNameCn: 'Please enter node name (CN)',
    inputNameEn: 'Please enter node name (EN)',
    inputSort: 'Please enter sort order',
    codeRequired: 'Node code is required',
    nameCnRequired: 'Node name (CN) is required',
    codePattern: 'Node code can only contain uppercase letters, numbers and underscores',
    sortPattern: 'Sort order must be a non-negative integer',
    uploadIcon: 'Upload Icon',
    changeIcon: 'Change Icon',
    iconTip: 'Support JPG, PNG format, recommended size 128x128px, max 2MB',
    iconTypeError: 'Invalid icon format, only JPG and PNG are supported',
    iconSizeError: 'Icon size cannot exceed 2MB',
    dragTip: 'Drag nodes to adjust order',
    noNodeTip: 'No nodes configured for current business, please add nodes',
    configTitle: 'Tracking Node Configuration',
    configInfo: 'Total {count} nodes | Drag to adjust order',
    stage: 'Stage code',
    stageNameCn: 'Stage name',
    inputStage: 'Enter stage code (e.g. origin / transit / destination)',
    inputStageNameCn: 'Enter stage display name (e.g. "Origin (Export)")',
    stageTip: 'Nodes sharing the same stage code are grouped together; the name is used as group title.'
  },

  supplierInput: {
    sectionTitle: 'Supplier input settings',
    enable: 'Enable supplier input',
    template: 'Preset template',
    templatePlaceholder: 'Select a template',
    applyTemplate: 'Apply template',
    fieldTable: 'Field configuration',
    colField: 'Field',
    colType: 'Type',
    colRequired: 'Required',
    colVisible: 'Visible',
    colAction: 'Action',
    configure: 'Configure',
    locked: 'Locked',
    fieldConfigTitle: 'Configure field: {name}',
    resetDefault: 'Restore defaults',
    resetDone: 'Restored to default configuration',
    templateApplied: 'Template applied',
    templateLoadFail: 'Failed to load template',
    lockedFieldTip: 'This field is locked by the system and cannot be modified',
    needVisibleField: 'When supplier input is enabled, at least one configurable field must be visible',
    fields: {
      status: 'Node status',
      exception_group: 'Exception details',
      estimated_time: 'Estimated time',
      actual_time: 'Actual time',
      estimated_remarks: 'Estimated remarks',
      actual_remarks: 'Actual remarks',
      attachments: 'Attachments'
    },
    fieldTypes: {
      status: 'Dropdown',
      exception_group: 'Fixed group',
      datetime: 'Date & time',
      text: 'Text',
      file: 'File upload'
    },
    templates: {
      pickup: {
        name: 'Pickup template',
        desc: 'For pickup-related nodes'
      },
      transit: {
        name: 'Transit template',
        desc: 'For in-transit nodes'
      },
      customs: {
        name: 'Customs template',
        desc: 'For customs/clearance nodes'
      },
      port: {
        name: 'Port template',
        desc: 'For port-related nodes'
      },
      delivery: {
        name: 'POD template',
        desc: 'For delivery / POD nodes'
      },
      common: {
        name: 'General template',
        desc: 'Standard setup for other nodes'
      }
    }
  },

  // Statistics related
  statistics: {
    totalNodes: 'Total Nodes',
    enabledNodes: 'Enabled Nodes',
    disabledNodes: 'Disabled Nodes',
    externalDisplayNodes: 'External Display Nodes'
  },

  // Action buttons
  action: {
    import: 'Import Config',
    export: 'Export Config',
    save: 'Save Config',
    editConfig: 'Edit Config',
    cancelEdit: 'Cancel Edit',
    cancel: 'Cancel',
    confirm: 'Confirm',
    reset: 'Reset',
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    view: 'View',
    close: 'Close',
    submit: 'Submit',
    back: 'Back'
  },

  // Status
  status: {
    enabled: 'Enabled',
    disabled: 'Disabled',
    yes: 'Yes',
    no: 'No',
    externalShow: 'External Display',
    externalHide: 'Internal Use'
  },

  // Messages
  message: {
    saveSuccess: 'Saved successfully',
    saveFail: 'Save failed',
    saveFailRetry: 'Save failed, please retry',
    networkError: 'Network error, please check your connection and retry',
    deleteSuccess: 'Deleted successfully',
    deleteFail: 'Delete failed',
    loadSuccess: 'Loaded successfully',
    loadFail: 'Load failed',
    uploadSuccess: 'Uploaded successfully',
    uploadFail: 'Upload failed',
    noData: 'No data',
    loading: 'Loading...',
    saving: 'Saving...',
    deleting: 'Deleting...',
    uploading: 'Uploading...',
    confirmSave: 'Are you sure to save current configuration?',
    confirmCancelEdit: 'Are you sure to cancel editing? Unsaved changes will be lost.',
    confirmDiscardNodeChanges: 'Discard changes to this node?',
    hasUnsavedChanges: 'You have unsaved changes, are you sure to leave?',
    selectChannelFirst: 'Please select a channel first',
    selectBusinessFirst: 'Please select a business first',
    pleaseEnterEditMode: 'Please click "Edit Config" button to enter edit mode first',
    cancelSuccess: 'Edit cancelled',
    atLeastOneNode: 'At least one node is required',
    atLeastOneBusiness: 'At least one business is required',
    businessNeedsNodes: 'Business "{name}" requires at least one node'
  },

  exceptionRule: {
    tabTitle: 'Exception Rules',
    nodeTabTitle: 'Tracking Nodes',
    addRule: 'Add Rule',
    enabledCount: 'Enabled',
    disabledCount: 'Disabled',
    empty: 'No exception rules',
    colCode: 'Rule Code',
    colName: 'Rule Name',
    colAlertLevel: 'Alert Level',
    alertLevelPlaceholder: 'Select alert level',
    alertLevelRequired: 'Please select alert level',
    colDesc: 'Description',
    colTriggerTimes: 'Trigger Times',
    colChannels: 'Channels',
    colRecipients: 'Recipients',
    colStatus: 'Status',
    colAction: 'Actions',
    statusEnabled: 'Enabled',
    statusDisabled: 'Disabled',
    channelSystem: 'System',
    channelEmail: 'Email',
    channelDingtalk: 'DingTalk',
    levelNormal: 'Normal',
    levelImportant: 'Important',
    levelUrgent: 'Urgent',
    deleteConfirm: 'Delete this rule?',
    presetCannotDelete: 'Preset rules cannot be deleted',
    enableSuccess: 'Enabled',
    disableSuccess: 'Disabled',
    saveSuccess: 'Saved',
    deleteSuccess: 'Deleted',
    runCheck: 'Run check',
    checkSuccess: 'Check done. {count} alert(s) triggered.',
    duplicateTimes: 'Duplicate trigger times. Please fix before saving.',
    duplicateLabel: 'Duplicate',
    editRuleTitle: 'Edit Exception Rule',
    addRuleTitle: 'Add Exception Rule',
    recipientOrderCreator: 'Order creator',
    recipientSales: 'Sales owner',
    businessAF: 'Intl Air',
    businessOF: 'Intl Ocean',
    businessIE: 'Intl Express',
    businessDE: 'Domestic Express',
    businessDL: 'Domestic Land',
    businessIL: 'Intl Land',
    orderRangeTitle: 'Order read range',
    orderRangeTip: 'Limit which orders are scanned by time range for this business type',
    orderRangePlaceholder: 'Not set — all orders will be scanned',
    orderRangeTimeBase: 'Time base',
    orderRangeTimeBasePlaceholder: 'Select time base',
    orderRangeTimeBaseRequired: 'Please select time base',
    timeBaseOrderTime: 'Order time',
    timeBaseCreateTime: 'Order created',
    timeBaseEtdTime: 'ETD',
    orderRangeStart: 'Start offset',
    orderRangeStartPlaceholder: '-30',
    orderRangeStartHint: '(negative = past)',
    orderRangeEnd: 'End offset',
    orderRangeEndPlaceholder: '0',
    orderRangeEndHint: '(positive = future)',
    orderRangeDayUnit: 'days',
    orderRangeIncludeNoTime: 'Include orders without time',
    orderRangeSave: 'Save',
    orderRangeReset: 'Reset',
    orderRangeResetConfirm: 'Reset to no time limit?',
    orderRangeSaveSuccess: 'Order read range saved',
    orderRangeResetSuccess: 'Reset — no time limit',
    orderRangeSavedInvalid: 'Saved, but range is invalid and will not apply to scans',
    orderRangeInvalidWarning: 'Invalid range: start cannot be after end',
    orderRangeToday: 'today',
    orderRangePastDays: 'past {days} days',
    orderRangeFutureDays: 'next {days} days',
    orderRangeTo: 'to',
    orderRangeFrom: 'from',
    orderRangeWithin: 'within'
  },

  alertPopup: {
    title: 'Tracking Alerts',
    waybillNo: 'Waybill No.',
    triggerTime: 'Triggered at',
    viewAll: 'View all {count} alerts',
    later: 'Later',
    dismissSession: 'Do not remind this session',
    viewDetail: 'View details'
  },

  // Form validation
  validation: {
    required: 'This field is required',
    pattern: 'Invalid format',
    maxLength: 'Length cannot exceed {max} characters',
    minLength: 'Length cannot be less than {min} characters',
    number: 'Please enter a number',
    integer: 'Please enter an integer',
    positive: 'Please enter a positive number',
    nonNegative: 'Please enter a non-negative number'
  }
}


